import React, { useState } from 'react';
import B2BService from '../../API/B2BService';
import { IconCheck, IconArrowRight } from '../../components/icons';
import cl from './Modal.module.css';

/**
 * Модалка «Заказать обратный звонок». Лид указывает тему, текст
 * запроса и удобное время. Заявка падает в админку Майнкрафтии.
 */
export default function CallbackModal({ onClose, defaultEmail, defaultPhone, defaultName }) {
    const [topic, setTopic] = useState('');
    const [message, setMessage] = useState('');
    const [phone, setPhone] = useState(defaultPhone || '');
    const [preferredTime, setPreferredTime] = useState('');
    const [name, setName] = useState(defaultName || '');
    const [submitting, setSubmitting] = useState(false);
    const [err, setErr] = useState('');
    const [done, setDone] = useState(false);

    async function submit(e) {
        e.preventDefault();
        setErr('');
        if (!topic.trim() && !message.trim()) {
            setErr('Заполните тему или текст запроса');
            return;
        }
        if (!phone.trim()) {
            setErr('Укажите телефон для звонка');
            return;
        }
        setSubmitting(true);
        const res = await B2BService.createRequest({
            kind: 'callback',
            payload: {
                topic: topic.trim(),
                message: message.trim(),
                preferred_time: preferredTime.trim(),
            },
            contact: {
                name: name.trim(),
                phone: phone.trim(),
                email: defaultEmail,
            },
        });
        setSubmitting(false);
        if (res.ok) {
            setDone(true);
        } else {
            setErr(res.message);
        }
    }

    return (
        <div className={cl.backdrop} onClick={onClose}>
            <div className={cl.modal} onClick={e => e.stopPropagation()}>
                <button className={cl.close} onClick={onClose} aria-label="Закрыть">×</button>

                {done ? (
                    <div className={cl.done}>
                        <div className={cl.doneIcon}>
                            <IconCheck width={42} height={42} strokeWidth={3}/>
                        </div>
                        <h2 className={cl.title}>Заявка отправлена</h2>
                        <p className={cl.lead}>
                            Перезвоним на <b>{phone}</b> в течение 1 рабочего дня
                            {preferredTime && <>, ориентируясь на «{preferredTime}»</>}.
                        </p>
                        <button className={cl.btnPrimary} onClick={onClose}>Понятно</button>
                    </div>
                ) : (
                    <form onSubmit={submit}>
                        <h2 className={cl.title}>Заказать звонок</h2>
                        <p className={cl.lead}>
                            Оставьте контакты и тему — перезвоним в рабочее время
                            и поможем с подключением, выбором тарифа или интеграцией.
                        </p>

                        {err && <div className={cl.err}>{err}</div>}

                        <div className={cl.field}>
                            <label htmlFor="topic">Тема</label>
                            <input id="topic" type="text" value={topic}
                                onChange={e => setTopic(e.target.value)}
                                placeholder="Например: оформление счёта на ООО"/>
                        </div>
                        <div className={cl.field}>
                            <label htmlFor="message">Текст запроса</label>
                            <textarea id="message" rows={3} value={message}
                                onChange={e => setMessage(e.target.value)}
                                placeholder="Расскажите, что нужно обсудить"/>
                        </div>
                        <div className={cl.field}>
                            <label htmlFor="phone">Телефон</label>
                            <input id="phone" type="tel" required value={phone}
                                onChange={e => setPhone(e.target.value)}
                                placeholder="+7 ___ ___-__-__"/>
                        </div>
                        <div className={cl.field}>
                            <label htmlFor="time">Удобное время (необязательно)</label>
                            <input id="time" type="text" value={preferredTime}
                                onChange={e => setPreferredTime(e.target.value)}
                                placeholder="Например: будни 14:00–18:00 МСК"/>
                        </div>

                        <button type="submit" className={cl.btnPrimary} disabled={submitting}>
                            {submitting
                                ? 'Отправляем…'
                                : <>Жду звонка <IconArrowRight width={16} height={16}/></>
                            }
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
}
